
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hardware/fullSceneTerminal",
      function () {
        return require("private-next-pages/hardware/fullSceneTerminal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hardware/fullSceneTerminal"])
      });
    }
  